import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import AboutMe from "../components/AboutMe";
import Photography from "../components/Photography";
import VideoWork from "../components/VideoWork";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="grain relative">
      <Navbar />
      <main>
        <Hero />
        <About />
        <AboutMe />
        <Photography />
        <VideoWork />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
